import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
@Component({
  selector: 'app-common-subproducts-alternate-blocks',
  templateUrl: './alternate-blocks.component.html',
  styleUrls: ['./alternate-blocks.component.scss'],
  imports: [CommonModule, ToHtmlPipe, UrlParamsPipe],
})
export class CommonSubProductsAlternateBlocksComponent implements OnInit {
  @Input() featureData: any;
  @Input() multicolor: any;
  @Input() bgColorData = [
    'blue-100',
    'pink-100',
    'grey-100',
    'green-100',
    'orange-100',
    'blue-100',
  ];
  @Input() isInside: any;
  @Input() reverse: any;
  @Input() imageBottom: any;
  queryParams: any;
  constructor(
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }
  _featureData: any;
  bgColors = ['blue-100', 'pink-100', 'grey-100', 'green-100'];
  ngOnInit(): void {
    this._featureData = {
      title: this.featureData?.title,
      blocks: this.featureData?.component1?.map((el: any) => el.fields),
    };
  }
  ngOnChanges(): void {
    this._featureData = {
      title: this.featureData?.title,
      blocks: this.featureData?.component1?.map((el: any) => el.fields),
    };
  }
  getBgClass(index: number) {
    let className = !this.multicolor ? 'grey-100' : this.bgColorData[index];

    className +=
      this.imageBottom && this.imageBottom.includes(index + 1)
        ? ' image-bottom'
        : '';
    return className;
  }
  isRevert(index: number) {
    let className = index % 2 === 0 ? '' : 'section-turbocharge-revert';
    if (this.reverse) {
      className = index % 2 === 0 ? 'section-turbocharge-revert' : '';
    }
    return className;
  }
}
